import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TaskExpirationService } from './service/task-expiration.service';
import { requestInterface } from 'src/app/util/interfaces/request';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Component({
	selector: 'register-form-task-expiration',
	templateUrl: './task-expiration.component.html',
	styleUrl: './task-expiration.component.scss',
})
export class TaskExpirationComponent implements OnInit {
	labels: any = {
		lbl_geral_cancelar: 'Cancel',
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_preencha_campo_obrigatorio: 'Please fill all the mandatory fields',
		lbl_configuracao_de_strike: 'Strike Configuration',
		lbl_modo_de_contagem_de_strike: 'Strike Counting Mode',
		lbl_strike_atual: 'Strike Atual',
		lbl_atualizacao_informacoes_strike: 'Strike Information Update',
		lbl_uma_vez_ao_dia: '1 time a day',
		lbl_duas_vezes_ao_dia: '2 times a day',
		lbl_tres_vezes_ao_dia: '3 times a day',
		lbl_quantos_strikes_por_dia: 'How Many Strikes per Day',
		lbl_intervalo_entre_strikes: 'Strike Interval',
		lbl_sem_strike: 'No Strike',
		lbl_geral_horas: 'hours',
		lbl_salvo_com_sucesso: 'Saved successfully',
		lbl_an_errour_occour: 'An error occurred. Please try again',
		lbl_geral_dias: 'days',
		lbl_escalonamento_dia: 'day',
		lbl_geral_dia: 'day',
		lbl_configuracao_aprovacao_tarefa: 'Approval Task Configuration',
		lbl_prazo_expiracao: 'Expiration Deadline',
	};

	icons: any = {
		faPencil: faPencil,
	};

	constructor(
		private taskExpirationService: TaskExpirationService,
		private labelsService: LabelsService,
		private cdr: ChangeDetectorRef,
		private notificationService: NotificationService
	) {}

	isLabelsLoading = true;
	isTaskExpirationLoading = true;
	selectedOption: string = null;
	isUpdating = false;
	showEditForm = false;

	taskExpiration: requestInterface[] = [];

	formUpdate: any = {
		expirationTime: null,
	};

	ngOnInit(): void {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLabelsLoading = false;
		});

		this.getTaskExpiration();
	}

	getTaskExpiration(): void {
		this.taskExpirationService.getTaskExpiration().subscribe((taskExpiration) => {
			this.taskExpiration = taskExpiration;
			this.isTaskExpirationLoading = false;
			this.cdr.detectChanges();
		});
	}

	saveModification(expirationTime: any): void {
		if (this.isUpdating) return;

		this.selectedOption === 'hour' ? (expirationTime = this.convertToMinutes(expirationTime).toString()) : expirationTime;
		if (this.selectedOption === 'day') {
			expirationTime = Number(expirationTime) * 24 * 60;
		}

		this.isUpdating = true;
		this.taskExpirationService.updateTaskExpiration(expirationTime).subscribe(
			() => {
				this.notificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.showEditForm = false;
				this.getTaskExpiration();
				this.isUpdating = false;
			},
			(error) => {
				this.notificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
				console.error('Error during update:', error);
				this.isUpdating = false;
			}
		);
	}

	convertToMinutes(timeString: string): number {
		if (typeof timeString === 'string' && timeString.includes(':')) {
			const hoursAndMinutes = timeString.split(':');
			const hoursInMinutes = Number.parseInt(hoursAndMinutes[0], 10) * 60;
			const minutes = Number.parseInt(hoursAndMinutes[1], 10);
			return hoursInMinutes + minutes;
		} else {
			console.error('Invalid time string:', timeString);
			return 0;
		}
	}

	convertToHours(minutes: any): string {
		const hours = Math.floor(minutes / 60);
		const remainingMinutes = minutes % 60;

		if (hours >= 24) {
			const days = Math.floor(hours / 24);
			const remainingHours = hours % 24;
			return `${days} ${days === 1 ? this.labels.lbl_escalonamento_dia : this.labels.lbl_geral_dias}`;
		} else {
			return `${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')} ${this.labels.lbl_geral_horas}`;
		}
	}

	openUpdatedForm(item: any): void {
		this.formUpdate = { ...item };
		this.showEditForm = !this.showEditForm;
	}
}
